<template>
	<div class="privacy-container">
		<!-- 返回按钮 -->
		<button class="back-button" @click="handleBack" data-lang="t_217">

		</button>

		<!-- 政策标题 -->
		<div class="privacy-header">
			<h1 data-lang="t_324"></h1>
		</div>

		<!-- 政策内容 -->
		<div class="privacy-content">
			<section class="privacy-section">
				<p>
					<span data-lang="t_325"></span><strong>AGE</strong>
					<span data-lang="t_326"></span>
				</p>

				<div class="important-text">
					<p><strong data-lang="t_327"></strong>
						<span data-lang="t_328"></span>
					</p>
				</div>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_329"></h2>
				<p data-lang="t_330"></p>

				<h3 data-lang="t_331"></h3>
				<p>
					<span data-lang="t_332"></span>
					<strong data-lang="t_333"></strong>
					<span data-lang="t_334"></span>
					<strong data-lang="t_335"></strong>、
					<strong data-lang="t_336"></strong>、
					<strong data-lang="t_337"></strong>
					<span data-lang="t_338"></span>
				</p>

				<h3 data-lang="t_339"></h3>
				<ul>
					<li>
						<strong data-lang="t_340"></strong>
						<span data-lang="t_341"></span>
						<strong data-lang="t_342"></strong>。
					</li>
					<li>
						<strong data-lang="t_343"></strong>
						<span data-lang="t_344"></span>
					</li>
				</ul>

				<h3 data-lang="t_345"></h3>
				<p>
					<span data-lang="t_346"></span>
					<strong data-lang="t_347"></strong>、
					<strong data-lang="t_348"></strong>
					<span data-lang="t_349"></span>
				</p>

				<h3 data-lang="t_350"></h3>
				<p data-lang="t_351"></p>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_352"></h2>
				<p data-lang="t_353"></p>

				<h3 data-lang="t_354"></h3>
				<p data-lang="t_355"></p>

				<h3 data-lang="t_356"></h3>
				<ul>
					<li><strong data-lang="t_357"></strong><span data-lang="t_358"></span></li>
					<li><strong data-lang="t_359"></strong><span data-lang="t_360"></span></li>
					<li>
						<strong data-lang="t_361"></strong>
						<span data-lang="t_362"></span>
						<strong data-lang="t_363"></strong>、
						<strong data-lang="t_364"></strong>
						<span data-lang="t_365"></span>
					</li>
				</ul>

				<h3 data-lang="t_366"></h3>
				<p data-lang="t_367"></p>

				<h3 data-lang="t_368"></h3>
				<p data-lang="t_369"></p>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_370"></h2>

				<div class="important-text">
					<p><strong data-lang="t_371"></strong>
						<span data-lang="t_372"></span>
					</p>
				</div>

				<h3 data-lang="t_373"></h3>
				<p data-lang="t_374"></p>
				<ul>
					<li data-lang="t_375"></li>
					<li data-lang="t_376"></li>
					<li data-lang="t_377"></li>
					<li data-lang="t_378"></li>
				</ul>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_379"></h2>
				<p data-lang="t_380"></p>

				<h3 data-lang="t_381"></h3>
				<p data-lang="t_382"></p>

				<h3 data-lang="t_383"></h3>
				<p>
					<span data-lang="t_384"></span>
					<strong data-lang="t_385"></strong>
					<span data-lang="t_386"></span>
				</p>

				<h3 data-lang="t_387"></h3>
				<p data-lang="t_388"></p>

				<h3 data-lang="t_389"></h3>
				<p>
					<span data-lang="t_390"></span>
					<strong data-lang="t_391"></strong>。</p>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_392"></h2>
				<p data-lang="t_393"></p>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_394"></h2>
				<div class="important-text">
					<p>
						<strong data-lang="t_395"></strong>
						<span data-lang="t_396"></span>
					</p>
				</div>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_397"></h2>
				<p data-lang="t_398"></p>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_399"></h2>
				<p data-lang="t_400"></p>
			</section>

			<section class="privacy-section">
				<h2 data-lang="t_401"></h2>
				<p data-lang="t_402"></p>
				<ul>
					<li><strong data-lang="t_403"></strong>：agegfgm@gmail.com</li>
					<li><strong>Twitter</strong>：https://x.com/alphasocialcha</li>
					<li><strong>telegram</strong>：https://t.me/alphasocialcha</li>
				</ul>
				<p data-lang="t_404"></p>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PrivacyPolicy',
		mounted() {
			this.setLanguage();
		},
		methods: {
			setLanguage(){
				const elements = document.querySelectorAll('[data-lang]');
				
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
					
				    element.innerHTML = Lang[lg][langValue];
				});
			},
			handleBack() {
				this.$emit('data-received', {
					message: 'profile',
					timestamp: new Date().toISOString(),
					source: 'privacy-policy'
				});
			}
		}
	}
</script>

<style scoped>
	.privacy-container {
		background-color: #000000;
		color: #e0e0e0;
		min-height: 100vh;
		padding: 20px;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
		line-height: 1.6;
	}

	.back-button {
		background: rgba(255, 255, 255, 0.05);
		border: 1px solid #333;
		color: #e0e0e0;
		padding: 10px 20px;
		border-radius: 6px;
		cursor: pointer;
		font-size: 16px;
		margin-bottom: 30px;
		transition: all 0.3s ease;
	}

	.back-button:hover {
		background: rgba(255, 255, 255, 0.1);
		border-color: #666;
	}

	.privacy-header {
		text-align: center;
		margin-bottom: 40px;
		padding-bottom: 20px;
		border-bottom: 1px solid #333;
	}

	.privacy-header h1 {
		color: #ffffff;
		font-size: 2.5rem;
		font-weight: 700;
		margin-bottom: 10px;
	}

	.last-updated {
		color: #999;
		font-size: 0.9rem;
	}

	.privacy-content {
		max-width: 900px;
		margin: 0 auto;
	}

	.privacy-section {
		margin-bottom: 40px;
	}

	.privacy-section h2 {
		color: #ffffff;
		font-size: 1.5rem;
		font-weight: 600;
		margin-bottom: 20px;
		padding-bottom: 10px;
		border-bottom: 1px solid #333;
	}

	.privacy-section h3 {
		color: #cccccc;
		font-size: 1.2rem;
		font-weight: 500;
		margin-top: 25px;
		margin-bottom: 15px;
	}

	.privacy-section p {
		margin-bottom: 16px;
		color: #cccccc;
	}

	.privacy-section ul {
		margin-bottom: 16px;
		padding-left: 24px;
	}

	.privacy-section li {
		margin-bottom: 8px;
		color: #cccccc;
	}

	.important-text {
		background: rgba(255, 255, 255, 0.05);
		border-left: 4px solid #666;
		padding: 16px;
		border-radius: 4px;
		margin: 20px 0;
	}

	/* 滚动条样式 */
	.privacy-content::-webkit-scrollbar {
		width: 6px;
	}

	.privacy-content::-webkit-scrollbar-track {
		background: rgba(255, 255, 255, 0.05);
	}

	.privacy-content::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.2);
		border-radius: 3px;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.privacy-container {
			padding: 15px;
		}

		.privacy-header h1 {
			font-size: 2rem;
		}

		.privacy-section h2 {
			font-size: 1.3rem;
		}
	}

	/* 打印样式 */
	@media print {
		.privacy-container {
			background-color: white !important;
			color: black !important;
		}

		.back-button {
			display: none;
		}

		.privacy-header h1 {
			color: black !important;
		}

		.privacy-section h2 {
			color: black !important;
		}

		.privacy-section h3 {
			color: #333 !important;
		}

		.privacy-section p,
		.privacy-section li {
			color: #333 !important;
		}
	}
</style>